module.exports = __webpack_public_path__ + "img/6diamonds.2dbd1fc2.jpg";